module.exports = __webpack_public_path__ + "img/icon_two_section_102.3605f626.png";